<template>
	<div class="news-header">
		<div class="header-content">
			<div class="top-row">
				<div class="brand" @click="goToHome" role="button" tabindex="0" @keydown.enter="goToHome">
					<div class="header-title">
						{{ $t('header.brand') }}
					</div>
					<div class="header-subtitle">
						{{ $t('header.subtitle.read') }} <span class="highlight-primary">{{ $t('header.subtitle.news') }}</span>, {{ $t('header.subtitle.collect') }} <span class="highlight-secondary">{{ $t('header.subtitle.words') }}</span>
					</div>
				</div>
				<div class="header-controls">
					<div class="header-actions">
						<slot name="actions"></slot>
					</div>
					<div class="header-user">
						<slot name="user"></slot>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { getCurrentUserStore } from '../../../store/services';
import { useResolvedPreferences } from '../../../composables/useResolvedPreferences';

const router = useRouter();
const userStore = getCurrentUserStore();
const resolved = useResolvedPreferences();

const goToHome = async () => {
	await userStore.initialize();
	const isAuthenticated = userStore.getCurrentUserId() != null;

	const nativeLanguage = resolved.nativeLanguage.value;
	const learnedLanguage = resolved.learnedLanguage.value;
	const mode = resolved.mode.value;

	if (nativeLanguage && learnedLanguage) {
		await router.push({ name: 'news-list', params: { nativeLanguage, learnedLanguage, mode } });
		return;
	}
	await router.push(isAuthenticated ? { name: 'my-settings' } : { name: 'intro' });
};
</script>

<style scoped>
.news-header {
	background: #000000;
	border-bottom: 1px solid rgba(255, 255, 255, 0.2);
	padding: 24px 24px 0px 24px;
}

.header-content {
	max-width: 960px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	//gap: 20px;
}

.top-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 24px;
	flex-wrap: nowrap;
}

.brand {
	display: flex;
	flex-direction: column;
	//gap: 8px;
	cursor: pointer;
	transition: opacity 0.2s ease;
	min-width: 0;
}

.brand:hover {
	opacity: 0.8;
}

.brand:focus {
	outline: 2px solid rgba(255, 255, 255, 0.5);
	outline-offset: 2px;
}

.header-title {
	font-family: logo;
	color: #ffffff;
	font-size: clamp(26px, 4.2vw, 40px);
	letter-spacing: 0.8px;
	line-height: 1.05;
	white-space: nowrap;
}

.header-subtitle {
	color: rgba(255, 255, 255, 0.85);
	line-height: 1.4;
	font-size: clamp(12px, 1.8vw, 16px);
	margin-top: -6px;
  text-shadow: 0px -4px 5px black;
  -webkit-text-stroke: black;
  -webkit-text-stroke-width: 0.1px;
}

.highlight-primary {
	color: #ffdaf9;
}

.highlight-secondary {
	color: #ff00d9;
}

.header-user {
	flex-shrink: 0;
}

.header-controls {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 16px;
	flex-wrap: nowrap;
	flex-shrink: 0;
}

.header-actions {
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: nowrap;
}

@media (max-width: 576px) {
	.news-header {
		padding: 16px 16px 12px 16px;
	}

	.top-row {
		gap: 8px;
	}

	.brand {
		flex: 1 1 0;
	}

	.header-title {
		font-size: clamp(22px, 7vw, 30px);
		letter-spacing: 0.5px;
	}

	.header-subtitle {
		margin-top: -4px;
	}
}


</style>
